import { IDeleteMaquinaEquipArquivoUseCase } from "../../../presentation/useCases/delete/delete_maquina_equip_arquivo_use_case";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

/**
 * DeleteMaquinaEquipArquivoUseCase
 */

export class DeleteMaquinaEquipArquivoUseCase implements IDeleteMaquinaEquipArquivoUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) { }

  async deleteMaquinaEquipArquivo(
    idMaquinaEquipArquivo: number,
    idMaquinaEquip: number,
  ): Promise<void> {
    await this.repository.deleteControledePatrimonioMaquinaEquipArquivo(idMaquinaEquipArquivo, idMaquinaEquip);
  }
}
